import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/byihuse-logo-blue.png'
import _imports_1 from '@/assets/images/logo/facebook.svg'
import _imports_2 from '@/assets/images/logo/twitter.svg'
import _imports_3 from '@/assets/images/logo/youtube.svg'
import _imports_4 from '@/assets/images/logo/usa_flag.svg'
import _imports_5 from '@/assets/images/logo/france_flag.svg'


const _hoisted_1 = { class: "footerx bg-black" }
const _hoisted_2 = { class: "container text-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "footer-logo"
}, null, -1)
const _hoisted_4 = { class: "footer-text" }
const _hoisted_5 = { class: "footer-links" }
const _hoisted_6 = { href: "javascript:;" }
const _hoisted_7 = { href: "javascript:;" }
const _hoisted_8 = { class: "footer-copyright" }
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"footer-socials\"><a href=\"javascript:;\" title=\"Facebook\"><img src=\"" + _imports_1 + "\" alt=\"\"></a><a href=\"javascript:;\" title=\"Twitter\"><img src=\"" + _imports_2 + "\" alt=\"\"></a><a href=\"javascript:;\" title=\"Youtube\"><img src=\"" + _imports_3 + "\" alt=\"\"></a></div>", 1)
const _hoisted_10 = { class: "footer-links" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "",
  class: "me-1",
  width: "14"
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: "",
  class: "me-1",
  width: "14"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("p", _hoisted_4, "Byihuse - " + _toDisplayString(_ctx.language.buy_online_happy), 1),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("a", _hoisted_6, _toDisplayString(_ctx.language.terms_serv), 1),
        _createTextVNode(" |  "),
        _createElementVNode("a", _hoisted_7, _toDisplayString(_ctx.language.priv_policy), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("span", null, _toDisplayString(_ctx.language.all_rights_reserved) + "s @" + _toDisplayString(_ctx.yearApp), 1)
      ]),
      _hoisted_9,
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("a", {
          href: "javascript:;",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setLang('en')))
        }, [
          _hoisted_11,
          _createElementVNode("span", null, _toDisplayString(_ctx.language.english_m), 1)
        ]),
        _createTextVNode("  |  "),
        _createElementVNode("a", {
          href: "javascript:;",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setLang('fr')))
        }, [
          _hoisted_12,
          _createElementVNode("span", null, _toDisplayString(_ctx.language.french_m), 1)
        ])
      ])
    ])
  ]))
}